module.exports = __webpack_public_path__ + "static/media/Clock.1b267207.svg";